import { IconErrorSmall } from '@components/icons/error-small';
import { Stack } from '@components/stack';
import { Text } from '@components/text';

export type FormErrorProps = {
  text?: string;
  isBold?: boolean;
};

export function FormError({ text, isBold }: FormErrorProps) {
  if (!text) return null;

  return (
    <Stack orientation="horizontal" space={1}>
      {/* The margin is so the icon can be in the middle of the first line if it breaks into multiple lines */}
      <IconErrorSmall color="error" style={{ marginTop: '0.125rem' }} />
      <Text font={isBold ? 'semibold14' : 'regular14'} color="error" text={text} />
    </Stack>
  );
}
